module.exports = __webpack_public_path__ + "img/compact.4a0c652b.png";